import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, CellMeasurerCache, CellMeasurer, List } from 'react-virtualized';
import _ from 'lodash';

class AutosizedVerticalList extends Component {
  constructor(props) {
    super(props);

    this.cache = new CellMeasurerCache({
      defaultHeight: props.defaultRowHeight,
      fixedWidth: props.fixedWidth,
    });

    this.listRef = null;

    this.recompute = this.recompute.bind(this);
    this.renderListItem = this.renderListItem.bind(this);
  }

  recompute() {
    if (this.listRef) {
      this.cache.clearAll();
      this.listRef.recomputeRowHeights();
    }
  }

  renderListItem({ index, key, parent, style }) {
    const { collection, renderItem, renderHeader } = this.props;
    const item = collection[index];

    if (item.header) {
      return (
        <CellMeasurer
          cache={this.cache}
          columnIndex={0}
          key={key}
          overscanRowCount={10}
          parent={parent}
          rowIndex={index}
        >
          <div style={style}>{renderHeader()}</div>
        </CellMeasurer>
      );
    }

    if (item) {
      return (
        <CellMeasurer
          cache={this.cache}
          columnIndex={0}
          key={key}
          overscanRowCount={10}
          parent={parent}
          rowIndex={index}
        >
          <div style={style}>{renderItem(item)}</div>
        </CellMeasurer>
      );
    }

    return null;
  }

  render() {
    const { collection, renderHeader } = this.props;
    const { rowHeight } = this.cache;

    if (renderHeader && !collection[0].header) {
      collection.unshift({ header: true });
    }

    const itemsCount = _.size(collection);

    return (
      <AutoSizer>
        {({ height, width }) => (
          <List
            height={height}
            ref={listRef => {
              this.listRef = listRef;
            }}
            rowCount={itemsCount}
            rowHeight={rowHeight}
            rowRenderer={this.renderListItem}
            width={width}
          />
        )}
      </AutoSizer>
    );
  }
}

AutosizedVerticalList.propTypes = {
  collection: PropTypes.arrayOf(PropTypes.any).isRequired,
  defaultRowHeight: PropTypes.number,
  fixedWidth: PropTypes.bool,
  renderItem: PropTypes.func.isRequired,
  renderHeader: PropTypes.func,
};

AutosizedVerticalList.defaultProps = {
  defaultRowHeight: 100,
  fixedWidth: true,
};

export default AutosizedVerticalList;
